import { render, staticRenderFns } from "./TestimonialsSection.vue?vue&type=template&id=171b0908&scoped=true&"
import script from "./TestimonialsSection.vue?vue&type=script&lang=js&"
export * from "./TestimonialsSection.vue?vue&type=script&lang=js&"
import style0 from "./TestimonialsSection.vue?vue&type=style&index=0&id=171b0908&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "171b0908",
  null
  
)

export default component.exports